import React, { useEffect } from 'react'
import { Dispatch } from 'redux'
import { connect } from 'react-redux'
import { selectCapabilities } from '../../selectors/capabilities'
import { getCapabilities } from '../../actions/capabilities'
import { ICapability } from '../../types/capability'
import { CapabilitiesTable } from './CapabilitiesTable'

export interface ICapabilitiesAllTab {
  list: ICapability[]
  dispatch: Dispatch
}

export const CapabilitiesAllTabComponent = ({
  list,
  dispatch,
}: ICapabilitiesAllTab) => {
  useEffect(() => {
    dispatch(getCapabilities())
  }, [dispatch])
  return <CapabilitiesTable list={list} />
}

export const CapabilitiesAllTab = connect(selectCapabilities)(
  CapabilitiesAllTabComponent
)
